import { render } from "./recover.html?vue&type=template&id=233e580c&external"
import script from "./recover.vue?vue&type=script&lang=js"
export * from "./recover.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__